import { analytics } from "@/telemetry/amplitude"

export function trackProjectCreatedEvent(project: { id: string; totalCount?: number }) {
	const customProperties: { projectId: string; totalCount?: number } = {
		projectId: project.id,
	}
	if (project.totalCount !== undefined) {
		customProperties.totalCount = project.totalCount
	}

	analytics.trackEvent({
		label: "project_created",
		type: "event",
		customProperties,
	})
}
